import cx from 'classnames';
import * as React from 'react';
import Token from 'components/Token';
import Text from 'components/Text';

import './styles/ComposerRecipientToken.scss';

export default class ComposerRecipientToken extends React.Component<any> {
  static propTypes = {
    children(props: any, propName: string) {
      if (React.Children.count(props[propName]) !== 2) {
        return new Error('ComposerRecipientToken expects two child elements');
      }
      return undefined;
    },
  };

  render() {
    const { children, ...tokenProps } = this.props;

    // @ts-expect-error ts-migrate(2488) FIXME: Type 'ReactNode' must have a '[Symbol.iterator]()'... Remove this comment to see the full error message
    const [avatar, text] = children;
    const styledAvatar = React.cloneElement(avatar, {
      className: cx('ComposerRecipientToken-avatar', avatar.props.className),
    });

    return (
      <Token className="ComposerRecipientToken" {...tokenProps}>
        <div className="ComposerRecipientToken-container">
          {styledAvatar}
          <Text className="ComposerRecipientToken-name">{text}</Text>
        </div>
      </Token>
    );
  }
}
